import { render, staticRenderFns } from "./FieldPermissionForm.vue?vue&type=template&id=6252102d&scoped=true"
import script from "./FieldPermissionForm.vue?vue&type=script&lang=js"
export * from "./FieldPermissionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6252102d",
  null
  
)

export default component.exports